import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { BindWalletUsecase } from '../../core/usecase/fs-wallet-account/bind-wallet-usecase';
import { PinCallbackUsecase } from '../../core/usecase/fs-wallet-account/pin-callback-usecase';

@Component({
  selector: 'wallet-binding',
  templateUrl: './wallet-binding.component.html',
  styleUrls: ['./wallet-binding.component.scss'],
})
export class WalletBindingComponent {
  wallet_id: string = '';
  accountId: string = '';
  authCode: string = '';
  partnerReferenceNo: string = '';
  status: "SUCCESS" | "FAILED" | ''  = '';
  isLoading = false;
  isBindingError = false;

  private readonly ngUnsubsribe$ = new Subject<void>();
  constructor(
    private readonly route: ActivatedRoute,
    private readonly bindWalletUsecase: BindWalletUsecase,
    private readonly pinCallbackUsecase: PinCallbackUsecase,
    private readonly messageService: MessageService,
    private readonly translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.ngUnsubsribe$)).subscribe((params) => {
      this.wallet_id = params.get('id') || '';
    });
    if (this.wallet_id) {
      this.route.queryParams
      .subscribe(params => {
        if(params['accountId']) {
          this.accountId = params['accountId'];
          this.partnerReferenceNo = params['partnerReferenceNo'];
          this.status = params['status'];
          this.pinCallback()
        }
      });
    }
  }

  bindWallet() {
    this.isLoading = true;
    this.bindWalletUsecase
      .execute(this.wallet_id)
      .pipe(takeUntil(this.ngUnsubsribe$))
      .subscribe({
      next: (res) => {
        this.isLoading = false;
        if(res.data?.next_action) {
          window.location.href = res.data?.next_action;
        }
      },
      error: (err) => {
          this.isLoading = false;
          this.isBindingError = true;
          window.postMessage(JSON.stringify({ 
            type: 'close', 
            payload: 'there is an error', redirectUrl: '' }));
          const error_detail =
              this.translateService.instant('messages.error');
          this.messageService.add({
              severity: 'error',
              detail: error_detail,
          });
      },
      });
  }

  pinCallback() {
    const data = {
        wallet_id: this.wallet_id,
        accountId: this.accountId,
        partnerReferenceNo: this.partnerReferenceNo || '',
        status: this.status,
    };
    this.pinCallbackUsecase
        .execute(data)
        .pipe(takeUntil(this.ngUnsubsribe$))
        .subscribe({
        next: (res) => {
        },
        error: (err) => {

            const error_detail =
                this.translateService.instant('messages.error');
            this.messageService.add({
                severity: 'error',
                detail: error_detail,
            });
        },
        });
  }
}
